export const LANDING_NFTS = ['2144', '613', '1784'];
